import Entity from '../entity'

export default class Backup extends Entity<number>{
    name: string;
    name_legal: string;
}


